import { styled } from "../../styles/stitches.config";
const SpinePath = styled('path', {
    // Use the css property to map the token
    // stroke: '$blue12', 
    stroke: 'black'
  });

const BackgroundPath = styled('path', {
    fill: 'gray'
})

export const BookLogo = () => (
  <svg 
    width="100%" 
    height="100%" 
    viewBox="0 0 70 20" 
    fill="none" 
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }} 
  >

    <BackgroundPath 
      d="M 6 1 Q 20.5 -4 35 7 Q 50 -2 64 1 L 69 15 Q 52 12 35 7 Q 18 12 1 15 Z" 
      fill="gray" 
    />

    {/* -------------------------------------------
       2. THE PAGES (The "Fan" Effect)
       - Added a 3rd page.
       - Control points (Q) lowered to make curves steeper.
    -------------------------------------------- */}
    
    {/* Page 1 (Top) - Starts at y=5, pulls to y=-2 (steep) */}
    {/* <path
      d="M 7 0 Q 21 -6 35 7 Q 49 -6 63 0"
    //   d="M 5 5 Q 20 -2 35 5 Q 50 -2 65 5"
      stroke="white" // Lighter Slate
      strokeWidth="1.25"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    /> */}


    <path
      d="M 6 2 Q 20.5 -4 35 7 Q 49.5 -4 64 2"
    //   d="M 5 5 Q 20 -2 35 5 Q 50 -2 65 5"
      stroke="white" // Lighter Slate
      strokeWidth="1.25"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />

    <path
      d="M 5 5 Q 20 -2 35 7 Q 50 -2 65 5"
    //   d="M 5 5 Q 20 -2 35 5 Q 50 -2 65 5"
      stroke="white" // Lighter Slate
      strokeWidth="1.25"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />

    {/* Page 2 (New Extra Page) - Slighly lower */}
    <path
      d="M 4 8 Q 19.5 2 35 7 Q 50.5 2 66 8"
    //   d="M 4 8 Q 19.5 2 35 5 Q 50.5 2 66 8"
      stroke="white" 
      strokeWidth="1.25"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />

    {/* Page 3 (Bottom Page) - Lower and wider */}
    <path
      d="M 3 11 Q 19 6 35 7 Q 51 6 67 11"
    //   d="M 3 11 Q 19 6 35 5 Q 51 6 67 11"
      stroke="white" 
      strokeWidth="1.25"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />

    <path
      d="M 2 14 Q 18.5 10 35 7 Q 51.5 10 68 14"
    //   d="M 3 11 Q 19 6 35 5 Q 51 6 67 11"
      stroke="white" 
      strokeWidth="1.25"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
    />

    {/* -------------------------------------------
       3. THE SPINE (The Cover)
    -------------------------------------------- */}
    <SpinePath
      d="M 1 19 Q 18 14 35 10 Q 52 14 69 19"
      strokeWidth="3" 
      vectorEffect="non-scaling-stroke"

    />
    <path
        d="M 31 11 
        Q 33 14 35 14 
        Q 37 14 39 11 
        L 35 10 Z"
        fill='black'
    />

    {/* 3. THE SPINE (The "Heel" of the book) */}

  </svg>
);